export default __webpack_public_path__ + "static/media/couple.1af7fecb.jpg";